@let participants = (this.participants$ | async) ?? [];
<div class="conversation-container">
  <div class="filters space-between align-center pl-space-sm">
    <div class="pl-space-sm">
      <cam-title [level]="3" [isBold]="true"> {{ 'communication.tasks.conversation.title' | translate }}</cam-title>
    </div>
    @if (participants && participants.length > 0) {
      <cam-conversation-filters
        [conversationParticipants]="participants"
        (filtersUpdated)="this.filters$.next($event)"
      ></cam-conversation-filters>
    }
  </div>
  <div class="communication-container pt-space-md" #scrollMe [scrollTop]="this.scrollTop()">
    @let communications = this.communications$ | async;
    <cam-loader [isLoading]="this.requestState.isLoading()">
      <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
        <cam-empty [isEmpty]="!communications || communications.length === 0">
          @if (communications) {
            <div class="list-container flex-column">
              <cam-message-list
                class="mx-space-sm"
                [readonly]="this.readonly()"
                [list]="communications"
                [conversationParticipants]="participants"
                [limit]="this.seeAll ? -1 : 3"
                [taskId]="this.taskId()"
                (askReply)="this.setReplyTo($event)"
              ></cam-message-list>
            </div>
          }
        </cam-empty>
      </cam-error>
    </cam-loader>
  </div>
  @if (!this.readonly()) {
    <div class="box-container" [class.out-of-box]="this.outOfBox()">
      <cam-loader [isLoading]="this.requestState.isLoading() || this.messageBoxRequestState.isLoading()">
        <div class="cadre">
          <cam-communication-message-box-container
            [taskId]="this.taskId()"
            [conversationParticipants]="participants"
            [statusTemplate]="this.statusTemplate()"
            [replyTo]="this.replyTo"
            [clear$]="this.clearBox$"
            [openPanel]="this.outOfBox()"
            [isChatEnabled]="this.isChatEnabled()"
            [isMailEnabled]="this.canSendMail()"
            (message)="this.sendMessage($event)"
            (toggleExpanded)="this.outOfBox.set(!this.outOfBox())"
          ></cam-communication-message-box-container>
        </div>
      </cam-loader>
    </div>
  }
  @if (this.outOfBox()) {
    <div class="overlay-bck" (click)="this.outOfBox.set(!this.outOfBox())"></div>
  }
</div>
